<template>
  <edit :aof="theme" @saved="saved" />
</template>

<script>
import edit from "../edit";
import dataStore from "@/services/api/store";
const HABIT_PROGRAM_STORE = "CoachHabitPrograms";

export default {
  components: {
    edit
  },
  data() {
    return {
      theme: {
        assign_all: true,
        pulse_survey: 1
      }
    };
  },
  created() {
    this.$eventHub.$emit("tutorial", "habitProgramDetail");
  },
  methods: {
    saved() {
      dataStore.create(HABIT_PROGRAM_STORE, this.theme).then(theme => {
        this.$emit("displaySnackbar", "Saved");
        this.$router.push({ name: "themesDetail", params: { id: theme.id } });
      });
    }
  }
};
</script>

<style>
</style>
